import ChildrenScreen from "./ChildrenScreen";
import ConsentScreen from "./ConsentScreen";
import CustomerProfileScreen from "./CustomerProfileScreen";
import MedicalCheckScreen from "./MedicalCheckScreen";
import DoctorProfileScreen from "./DoctorProfileScreen";
import MedicalScreen from "./MedicalScreen";
import RatingScreen from "./RatingScreen";
import SymptomsScreen from "./SymptomsScreen";
import WaitingScreen from "./WaitingScreenBaymax";
import AskScreen from "./AskScreen";
import IntroScreen from "./IntroScreen";
import VideoCallScreen from "./VideoCallScreen";
import AudioCallScreen from "./AudioCallScreen";
import PreAssessmentScreen from "./PreAssessmentScreen";
import PostAssessmentScreen from "./PostAssessmentScreen";
import PrescriptionHistoryScreen from "./PrescriptionHistory";
import PrescriptionHistoryDetailScreen from "./PrescriptionDetail";
import PrescriptionHistoryDetailStatusScreen from "./PrescriptionDetailStatus";
import PrescriptionDetailScreen from "./PrescriptionDetailScreen";
import OrderMedicineScreen from "./OrderMedicineScreen";

export const routeConfigMap = {
  ask: AskScreen,
  intro: IntroScreen,
  Children: ChildrenScreen,
  Consent: ConsentScreen,
  dependencies: ChildrenScreen,
  CustomerProfile: CustomerProfileScreen,
  DoctorProfile: DoctorProfileScreen,
  Medical: MedicalScreen,
  MedicalCheck: MedicalCheckScreen,
  Rating: RatingScreen,
  Symptoms: SymptomsScreen,
  symptom: SymptomsScreen,
  VideoCall: VideoCallScreen,
  AudioCall: AudioCallScreen,
  Waiting: WaitingScreen,
  PreAssessment: PreAssessmentScreen,
  PostAssessment: PostAssessmentScreen,
  PrescriptionHistory: PrescriptionHistoryScreen,
  PrescriptionHistoryDetail: PrescriptionHistoryDetailScreen,
  PrescriptionHistoryDetailStatus: PrescriptionHistoryDetailStatusScreen,
  PrescriptionDetail: PrescriptionDetailScreen,
  OrderMedicine: OrderMedicineScreen,
};

export const stackConfig = {
  headerMode: "none",
  initialRouteName: "CustomerProfile",
};
